
import {Component, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {abstractField} from "vue-form-generator";
import ContactSelector from "@/components/contact/ContactSelector.vue";

@Component({
  components: {ContactSelector}
})
export default class ContactSelectorField extends mixins(Vue, abstractField) {
  get resolver() {
    // @ts-ignore
    return () => this.schema.resolver(this.model)
  }

  get contactTypes() {
    // @ts-ignore
    return this.schema.contactTypes
  }
}
